import { buildContext } from '@toss/react';
import { type BuildFormControl } from '../type';
export const [QuizControlProvider, useQuizControl] = buildContext<{
  control: BuildFormControl;
  index: number;
  id: string;
}>('QuizControlProvider');